import React from 'react';
import { Col, Row } from 'react-bootstrap5';

import StatisticButton from 'components/Managers/Dashboard/Views/Statistics/StatisticButton';
import useStatistics from 'components/Common/Affiliates/Hooks/useStatistics';
import currencyFormat from 'components/Widgets/currencyFormat';

export default function Statistics() {
  const { statistics } = useStatistics();

  return (
    <Row>
      <Col md={6} className="mb-2 mb-md-0">
        <StatisticButton
          label="Total Payments to Date"
          value={statistics ? currencyFormat(statistics.total_payments, { currency: 'USD' }) : null}
          onClick={() => {}}
          className="bg-primary-50 pe-none"
        />
      </Col>

      <Col md={6} className="mb-2 mb-md-0">
        <StatisticButton
          label="Year-to-Date Payments"
          value={statistics ? currencyFormat(statistics.current_year_payments, { currency: 'USD' }) : null}
          onClick={() => {}}
          className="bg-primary-50 pe-none"
        />
      </Col>
    </Row>
  );
}
